import { Suspense, useEffect, useState } from "react";
import {
  configureFirstIframe,
  getLayoutDirection,
  isAndroid,
  isMobileApp,
  isMobileBrowser,
  openPdfToUrl } from
"../../utils/util";
import WarningInfo from "../../common/WarningInfo";
import { ServiceTranslation } from "../../utils/constants";
import { Loader } from "../../common/Loader";
import { fetchTranslationData } from "../../services/translation/translation";
import { getPatientCertificates, getPatientCertificatesUrl } from "../../services/liferay/escortLeave";
import EscortLeaveCard from "./EscortLeaveCard";
import CertificateModal from "./EscortCertificateModal";

const EscortLeave = () => {
  const [patientCertificates, setPatientCertificates] = useState([]);
  const [modalContent, setModalContent] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [translationMap, setTranslationMap] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [exceptionError, setExceptionError] = useState(false);
  const [errorHeading, setErrorHeading] = useState("");
  const [errorSubHeading, setErrorSubHeading] = useState("");
  const [indexValue, setIndexValue] = useState();

  useEffect(() => {
    window.parent.scrollTo(0, 0);
    setIsMobile(isMobileApp());

    const loadData = async () => {
      try {
        const translationResult = await fetchTranslationData(
          ServiceTranslation.EscortLeave
        );


        setTranslationMap(translationResult);

        const result = await getPatientCertificates();
        const data = result.data || [];
        setPatientCertificates(data);
        if (data.length > 0 && data.length < 3) {

          const length = isMobileBrowser() ?
          460 + 340 * data.length :
          170 + 300 * 2;
          configureFirstIframe(200, length, true);
        }
        else if (data.length > 2) {
          const length = isMobileBrowser() ?
          460 + 340 * data.length :
          170 + 200 * data.length;
          configureFirstIframe(200, length, true);
        } else
        {
          configureFirstIframe(200, -650);
        }
      } catch (error) {
        console.error("Error loading data:", error);
        setExceptionError(false);
        setErrorHeading(
          translationMap?.somethingWentWrongMesg ??
          "Something went wrong. Please try again later."
        );
        setErrorSubHeading("");
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleViewCertificate = async (index, type, e) => {
    const patientDetail = patientCertificates[index];
    setIndexValue(index);

    if (type === "view") {
      setModalContent(patientDetail);
      window.parent.scrollTo(0, 0);
      setShowModal(true);
    } else if (type === "download") {
      const button = e.target.closest(".button2");

      button.classList.add("active");
      const base64 = await getPatientCertificatesUrl(patientDetail.id);
      let dataUrl = openPdfToUrl(base64.data);

      if (isMobile) {
        if (isAndroid()) {
          window.open(dataUrl, "_parent");
        } else {
          const fileName = `EscortLeaveCertificate_${patientDetail.id}.pdf`;
          if (navigator.canShare) {
            try {
              const binary = atob(base64.data);
              const bytes = new Uint8Array(binary.length);
              for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
              }
              const pdfFile = new File([bytes], fileName, { type: "application/pdf" });
              if (navigator.canShare({ files: [pdfFile] })) {
                await navigator.share({ files: [pdfFile], title: fileName });
              }
            } catch (shareError) {
            }
          }
        }
      }

      setTimeout(() => {
        button.classList.remove("active");
        button.querySelector("i").classList.replace("fa-download", "fa-check");
        button.querySelector("span").innerText = translationMap?.downloaded;
        button.classList.add("download1");

        if (!isMobile) {
          window.open(dataUrl, "_blank");
        }
      }, 6000);
    }
  };

  const closeModal = () => {
    window.parent.scrollTo(0, 0);
    setShowModal(false);
  };


  if (isLoading) return <Loader />;

  return (
    <div
      className={` custombody_color ${getLayoutDirection()}`}
      id="sectionSickLeave">
      
            <section
        className="w-100 clearfix SickLeaveConfirmationSection"
        id="CoverPlanActive">
        
                <div className="container customContainer">
                    {!isMobile &&
          <div className="Title_Inner_Box">
                            <h6 className="MainTitleOne">
                                {translationMap?.escort_leave_certificate}
                            </h6>
                        </div>
          }
                    <div className="cover_inner_wrapper cover_inner_wrapper2">
                        <div className="cover_main_box1">

                            {patientCertificates && patientCertificates.length > 0 ?
              <>
                                    {exceptionError &&
                <WarningInfo
                  setError={setExceptionError}
                  alert_text={errorHeading}
                  number_text={errorSubHeading} />

                }

                                    <div className="Result_Title_Box">
                                        <p className="Gray_Title">
                                            {translationMap?.showing} {patientCertificates.length}{" "}
                                            {translationMap?.results}
                                        </p>
                                    </div>

                                    {!isLoading &&
                patientCertificates &&
                patientCertificates.map((patient, index) =>
                <EscortLeaveCard
                  key={index}
                  data={index}
                  doctorName={patient.doctorName}
                  toDate={patient.leaveEndDate}
                  fromDate={patient.leaveStartDate}
                  orderPlaceDate={patient.orderPlacedDateTime}
                  onViewCertificate={handleViewCertificate}
                  translationMap={translationMap}
                  isMobile={isMobile}
                  isSignaturePresent={patient.signatureIsPresent} />

                )}
                                </> :

              <>
                                    <div
                  className="AlertInnerBox YellowAlertInnerBox alert alert-dismissible fade show">
                                        <div className="Icon_box">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                            <a href="javascript:void(0);">
                                                <span className="material-symbols-outlined">info</span>
                                            </a>
                                        </div>
                                        <div className="alert_text">
                                            <h6>
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                                <a href="javascript:void(0);">
                                                    {translationMap?.no_escort_leave_certificates}
                                                </a>
                                            </h6>
                                            <p className="number_txt"></p>
                                        </div>
                                    </div>
                                </>
              }
                        </div>
                    </div>
                </div>
            </section>

            {showModal &&
      <Suspense fallback={<div>Loading...</div>}>
                    <CertificateModal
          show={showModal}
          onClose={closeModal}
          content={modalContent}
          translationMap={translationMap}
          onViewCertificate={handleViewCertificate}
          data={indexValue}
          isMobile={isMobile} />

                </Suspense>
      }

        </div>);

};

export default EscortLeave;